{
  "schemaVersion": "mobile-ui.v2",
  "revision": "2026.09.26.1",
  "theme": {
    "accent": "jade",
    "appearance": "system",
    "density": "comfortable"
  },
  "app": {
    "brandLabel": "EPIC",
    "productLabel": "Owner workspace",
    "loadingMessage": "Opening your workspace...",
    "signIn": {
      "eyebrow": "EPIC owner app",
      "title": "Sign in to EPIC",
      "body": "Connect this app directly to your EPIC account with your username and password.",
      "actionLabel": "Sign in",
      "usernameLabel": "Username",
      "usernamePlaceholder": "Your EPIC username",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Your password",
      "showPasswordLabel": "Show password",
      "hidePasswordLabel": "Hide password",
      "dividerLabel": "or",
      "googleActionLabel": "Continue with Google",
      "googleBrowserNote": "Google verifies your identity. EPIC still applies account access and two-step verification.",
      "twoFactorEyebrow": "Two-step verification",
      "twoFactorTitle": "Verify it is you",
      "twoFactorBody": "Enter the current code from your authenticator app or one unused recovery code.",
      "codeLabel": "Authenticator or recovery code",
      "codePlaceholder": "Enter your code",
      "verifyActionLabel": "Verify and continue",
      "backActionLabel": "Use a different account"
    },
    "noAccount": {
      "eyebrow": "Workspace required",
      "title": "No active workspace",
      "body": "Your session is active, but there is no workspace available for this account.",
      "actionLabel": "Sign out"
    },
    "copy": {
      "workspaceLabel": "EPIC account",
      "contactFallback": "Unknown contact",
      "noPreview": "No message preview",
      "attachmentFallback": "Attachment",
      "contentUnavailable": "Message content unavailable",
      "timeUnavailable": "Time unavailable",
      "channelFallback": "Message",
      "unassignedLabel": "Unassigned",
      "systemAuthor": "EPIC",
      "unreadLabel": "unread",
      "errorTitle": "We couldn't load this view",
      "retryLabel": "Try again",
      "offlineToast": "You're offline. Showing the latest loaded view."
    }
  },
  "tabs": [
    { "key": "home", "label": "Home", "icon": "home" },
    { "key": "inbox", "label": "Inbox", "icon": "inbox" },
    { "key": "olivia", "label": "WCTEK AI", "icon": "sparkles" },
    { "key": "create", "label": "Create", "icon": "square-plus" },
    { "key": "profile", "label": "Profile", "icon": "user-round" }
  ],
  "chrome": {
    "header": {
      "id": "app-header",
      "kind": "app-header",
      "slot": "primary"
    },
    "navigation": {
      "id": "bottom-navigation",
      "kind": "bottom-navigation",
      "slot": "primary"
    }
  },
  "screens": {
    "home": {
      "key": "home",
      "title": "Home",
      "layout": "stack",
      "components": [
        {
          "id": "home-connection",
          "kind": "connection-status",
          "slot": "primary",
          "icon": "wifi-off",
          "tone": "warning",
          "title": "You're offline",
          "body": "Showing information already loaded on this device."
        },
        {
          "id": "account-overview",
          "kind": "account-overview",
          "slot": "primary",
          "eyebrow": "EPIC account",
          "body": "Your conversations and owner tools, together in one focused view.",
          "labels": {
            "online": "Connected",
            "offline": "Offline"
          }
        },
        {
          "id": "inbox-preview",
          "kind": "inbox-preview",
          "slot": "primary",
          "eyebrow": "Recent",
          "title": "Inbox",
          "body": "The latest conversations in this workspace.",
          "maxItems": 3,
          "labels": {
            "loading": "Loading recent conversations...",
            "empty": "No conversations are available yet."
          },
          "action": {
            "name": "back-to-inbox",
            "label": "View all",
            "icon": "arrow-right"
          }
        },
        {
          "id": "workspace-tools",
          "kind": "summary-grid",
          "slot": "primary",
          "eyebrow": "Workspace",
          "title": "Owner tools",
          "items": [
            {
              "key": "olivia",
              "title": "My AI companion",
              "titleSource": "active-companion-name",
              "status": "Companion profile",
              "body": "Review the identity, communication style, and boundaries saved for this EPIC account.",
              "icon": "sparkles",
              "tone": "accent",
              "action": {
                "name": "open-profile-view",
                "label": "Open companion settings",
                "icon": "arrow-right",
                "profileView": "ai-customize"
              }
            },
            {
              "key": "create",
              "title": "Create",
              "status": "Coming next",
              "body": "Media preparation and scheduling will appear after their mobile contracts are verified.",
              "icon": "square-plus",
              "tone": "warning",
              "action": {
                "name": "navigate",
                "label": "Open Create",
                "icon": "arrow-right",
                "tab": "create"
              }
            },
            {
              "key": "profile",
              "title": "Profile",
              "status": "Available",
              "body": "Review the active EPIC account and manage this session.",
              "icon": "user-round",
              "tone": "success",
              "action": {
                "name": "navigate",
                "label": "Open Profile",
                "icon": "arrow-right",
                "tab": "profile"
              }
            }
          ]
        }
      ]
    },
    "inbox": {
      "key": "inbox",
      "title": "Inbox",
      "layout": "inbox",
      "components": [
        {
          "id": "inbox-heading",
          "kind": "screen-heading",
          "slot": "primary",
          "eyebrow": "Messages",
          "title": "Inbox",
          "body": "Stay close to every conversation in this workspace.",
          "action": {
            "name": "refresh-inbox",
            "label": "Refresh Inbox",
            "icon": "refresh-cw"
          }
        },
        {
          "id": "inbox-connection",
          "kind": "connection-status",
          "slot": "primary",
          "icon": "wifi-off",
          "tone": "warning",
          "title": "You're offline",
          "body": "Conversation updates will resume when your connection returns."
        },
        {
          "id": "conversation-list",
          "kind": "conversation-list",
          "slot": "primary",
          "labels": {
            "ariaLabel": "Conversations",
            "loading": "Loading conversations...",
            "empty": "No contacts match these Inbox filters.",
            "loadMore": "Load more contacts",
            "filters": "Filter Inbox",
            "closeFilters": "Close Inbox filters",
            "activeFilters": "active filters",
            "defaultView": "All open contacts",
            "search": "Search",
            "searchPlaceholder": "Name, handle, or message",
            "channel": "Channel",
            "allChannels": "All channels",
            "instagramChannel": "Instagram",
            "tiktokChannel": "TikTok",
            "xChannel": "X",
            "smsChannel": "SMS",
            "rcsChannel": "RCS",
            "imessageChannel": "iMessage",
            "companionChannel": "EPIC / Companion",
            "status": "Status",
            "open": "Open",
            "closed": "Closed",
            "allStatuses": "All statuses",
            "sort": "Sort",
            "latestInbound": "Latest inbound",
            "latestMessage": "Latest message",
            "folders": "Folders",
            "labels": "Labels",
            "noLabels": "No canonical labels are available.",
            "applyFilters": "Apply filters",
            "resetFilters": "Clear filters",
            "offline": "Reconnect to apply",
            "metadataUnavailable": "Folders and labels are unavailable. You can still use search, channel, status, and sort.",
            "deletedPreview": "Message removed",
            "historyReview": "Imported history needs review",
            "historyReviewBody": "This imported history could not be linked safely to a contact conversation.",
            "importedHistory": "Imported",
            "partialHistory": "Partial history",
            "attachment": "Has attachment",
            "contactHistory": "conversations",
            "companionState": "Unavailable"
          }
        },
        {
          "id": "conversation-detail",
          "kind": "conversation-detail",
          "slot": "detail",
          "labels": {
            "back": "Back to Inbox",
            "loading": "Opening conversation...",
            "noSelection": "Choose a conversation to read its messages.",
            "loadEarlier": "Load earlier messages",
          "messageEmpty": "This conversation has no messages yet.",
          "replyTitle": "Replies are not available yet",
          "replyBody": "Mobile sending stays protected until authorization, duplicate prevention, and provider checks are verified.",
          "composerLabel": "Inbox composer",
          "composerMode": "Composer mode",
          "replyMode": "Reply",
          "noteMode": "Note",
          "replyPlaceholder": "Write a reply for review",
          "notePlaceholder": "Write an internal note",
          "queueReply": "Queue for review",
          "saveNote": "Save note",
          "saving": "Saving...",
          "discardLogout": "Discard this unsaved Inbox draft and sign out?",
          "composerOffline": "Reconnect before saving this draft.",
          "replyReviewBoundary": "Replies are saved for human review and are not sent automatically.",
          "noteBoundary": "Notes stay inside EPIC and are never sent to the contact.",
          "draftEyebrow": "SMS review",
          "draftReviewTitle": "Review AI draft",
          "draftReviewBody": "Check and edit the exact message before approval.",
          "draftTextLabel": "Draft message",
          "draftNeedsReview": "Needs review",
          "draftApproved": "Approved",
          "draftAccepted": "Accepted for delivery",
          "draftSent": "Sent",
          "draftDelivered": "Delivered",
          "draftFailed": "Delivery failed",
          "draftRejected": "Rejected",
          "draftUnavailable": "Unavailable",
          "draftApprovalBoundary": "Approval does not send the message.",
          "draftReasonLabel": "Rejection reason",
          "draftReasonChanges": "Needs changes",
          "draftReasonUnsafe": "Unsafe or incorrect",
          "draftReasonContext": "Wrong context",
          "draftReasonOther": "Operator rejected",
          "draftReviewUnavailable": "Draft review is not available for this account.",
          "draftReviewOffline": "Reconnect before reviewing this draft.",
          "draftReject": "Reject",
          "draftRejecting": "Rejecting...",
          "draftApprove": "Approve",
          "draftApproving": "Approving...",
          "draftSendBoundary": "Only the approved text will be sent.",
          "draftSendUnavailable": "Sending remains blocked until the SMS connection passes every safety check.",
          "draftRejectedBody": "This draft will not be sent.",
          "draftFailedBody": "Delivery failed. Sending remains blocked until the conversation is refreshed.",
          "draftCompleteBody": "This draft is no longer awaiting review.",
          "draftTextUnavailable": "Draft text unavailable.",
          "draftSendConfirm": "I reviewed this exact message and want to send it.",
          "draftSend": "Send approved message",
          "draftSending": "Sending...",
          "contextTitle": "Contact context",
          "contextLoading": "Loading contact context...",
          "contextUnavailable": "Unavailable",
          "contextUnavailableBody": "Contact context is not available for this conversation.",
          "contextIdentity": "Identity",
          "contextConsent": "Consent",
          "contextRelationship": "Relationship",
          "contextMemory": "Memory",
          "contextMemories": "memories",
          "contextReceive": "Receive",
          "contextSend": "Send",
          "contextHistory": "History",
          "contextIdentifiers": "Identifiers",
          "contextTags": "Labels",
          "contextRelationshipSummary": "Relationship context",
          "contextMemorySummary": "Active memory"
        }
        }
      ]
    },
    "olivia": {
      "key": "olivia",
      "title": "WCTEK AI",
      "layout": "stack",
      "components": [
        {
          "id": "wctek-chat",
          "kind": "wctek-chat",
          "slot": "primary",
          "icon": "sparkles",
          "tone": "accent",
          "eyebrow": "Core AI",
          "title": "WCTEK AI",
          "body": "Work with EPIC's core AI in an account-scoped conversation. WCTEK AI can coordinate approved agents, but mobile tools remain read-only.",
          "labels": {
            "ariaLabel": "WCTEK AI conversation",
            "assistantAuthor": "WCTEK",
            "status": "Read-only tools",
            "loading": "Opening WCTEK AI...",
            "loadingHistory": "Loading recent conversations...",
            "loadHistory": "Reload recent conversations",
            "recentConversations": "Recent conversations",
            "empty": "No previous WCTEK AI conversations yet.",
            "emptyConversation": "Start a conversation with a question, task, or idea.",
            "newConversation": "New conversation",
            "composerLabel": "Message WCTEK AI",
            "composerPlaceholder": "Ask WCTEK AI to help with a task...",
            "sendMessage": "Send message",
            "sending": "WCTEK AI is working...",
            "cancel": "Stop request",
            "retry": "Try opening WCTEK AI again",
            "retrySend": "Retry message",
            "disabled": "WCTEK AI chat is not enabled for this environment. No request will be sent until the server gate is enabled.",
            "offlineChat": "Reconnect to continue. Your unsent message stays on this device only until you sign out or close the app.",
            "specialists": "Agents",
            "you": "You",
            "discardDraft": "Discard this unsent WCTEK AI draft and change conversations?",
            "discardLogout": "Discard this unsent WCTEK AI draft and sign out?"
          }
        }
      ]
    },
    "create": {
      "key": "create",
      "title": "Create",
      "layout": "stack",
      "components": [
        {
          "id": "create-placeholder",
          "kind": "placeholder",
          "slot": "primary",
          "icon": "square-plus",
          "tone": "warning",
          "eyebrow": "Content",
          "title": "Create",
          "body": "Capture, upload, approval, and scheduling controls will arrive after the mobile media contract is verified.",
          "labels": {
            "status": "Coming next"
          }
        }
      ]
    },
    "profile": {
      "key": "profile",
      "title": "Profile",
      "layout": "stack",
      "components": [
        {
          "id": "profile-summary",
          "kind": "profile-summary",
          "slot": "primary",
          "profileView": "hub",
          "eyebrow": "Account",
          "title": "Profile",
          "body": "Manage this EPIC account, its public profile, and its AI tools.",
          "labels": {
            "workspace": "Active EPIC account",
            "signedInAs": "Signed in as",
            "sessionStatus": "Session",
            "active": "Active"
          }
        },
        {
          "id": "profile-hub",
          "kind": "summary-grid",
          "slot": "primary",
          "profileView": "hub",
          "eyebrow": "Manage",
          "title": "Profile tools",
          "items": [
            {
              "key": "account-profile",
              "title": "Customize your profile",
              "status": "Profile and socials",
              "body": "Add and organize the social links shown beneath this EPIC account.",
              "icon": "user-cog",
              "tone": "success",
              "action": {
                "name": "open-profile-view",
                "label": "Open profile customization",
                "icon": "arrow-right",
                "profileView": "account"
              }
            },
            {
              "key": "ai-manager",
              "title": "AI Manager",
              "status": "Companion and connections",
              "body": "Manage your companion profile, check-ins, drafts, memory, and provider connections.",
              "icon": "sparkles",
              "tone": "accent",
              "action": {
                "name": "open-profile-view",
                "label": "Open AI Manager",
                "icon": "arrow-right",
                "profileView": "ai-manager"
              }
            }
          ]
        },
        {
          "id": "social-links-settings",
          "kind": "social-links-settings",
          "slot": "primary",
          "profileView": "account",
          "eyebrow": "Public profile",
          "title": "Customize your profile",
          "body": "Add the social destinations you want visitors to find from this EPIC account.",
          "labels": {
            "back": "Back to Profile",
            "settingsAriaLabel": "Profile social links",
            "loading": "Loading profile links...",
            "retry": "Try again",
            "enabled": "Show social links on my profile",
            "platform": "Platform",
            "label": "Display label",
            "url": "Profile URL or handle",
            "visible": "Show this link",
            "empty": "No social links have been added yet.",
            "add": "Add social link",
            "moveUp": "Move link up",
            "moveDown": "Move link down",
            "remove": "Remove link",
            "reload": "Reload profile links",
            "save": "Save profile links",
            "saving": "Saving profile links...",
            "saved": "Profile links saved.",
            "unsaved": "You have unsaved profile-link changes.",
            "offlineSave": "Reconnect before saving profile links."
          },
          "options": [
            { "value": "instagram", "label": "Instagram" },
            { "value": "tiktok", "label": "TikTok" },
            { "value": "facebook", "label": "Facebook" },
            { "value": "x", "label": "X" },
            { "value": "threads", "label": "Threads" },
            { "value": "snapchat", "label": "Snapchat" },
            { "value": "bluesky", "label": "Bluesky" },
            { "value": "mastodon", "label": "Mastodon" },
            { "value": "pinterest", "label": "Pinterest" },
            { "value": "youtube", "label": "YouTube" },
            { "value": "twitch", "label": "Twitch" },
            { "value": "kick", "label": "Kick" },
            { "value": "discord", "label": "Discord" },
            { "value": "reddit", "label": "Reddit" },
            { "value": "linkedin", "label": "LinkedIn" },
            { "value": "github", "label": "GitHub" },
            { "value": "spotify", "label": "Spotify" },
            { "value": "apple-music", "label": "Apple Music" },
            { "value": "soundcloud", "label": "SoundCloud" },
            { "value": "bandcamp", "label": "Bandcamp" },
            { "value": "patreon", "label": "Patreon" },
            { "value": "ko-fi", "label": "Ko-fi" },
            { "value": "buy-me-a-coffee", "label": "Buy Me a Coffee" },
            { "value": "paypal", "label": "PayPal" },
            { "value": "venmo", "label": "Venmo" },
            { "value": "cash-app", "label": "Cash App" },
            { "value": "custom", "label": "Website" }
          ]
        },
        {
          "id": "ai-manager-heading",
          "kind": "screen-heading",
          "slot": "primary",
          "profileView": "ai-manager",
          "eyebrow": "Manage",
          "title": "AI Manager",
          "body": "Open focused tools for your companion profile, check-ins, messaging, memory, and provider connections.",
          "action": {
            "name": "open-profile-view",
            "label": "Back to Profile",
            "icon": "arrow-left",
            "profileView": "hub"
          }
        },
        {
          "id": "ai-manager-menu",
          "kind": "summary-grid",
          "slot": "primary",
          "profileView": "ai-manager",
          "eyebrow": "Tools",
          "title": "AI settings",
          "items": [
            {
              "key": "ai-customize",
              "title": "Customize your AI",
              "status": "Identity and boundaries",
              "body": "Set the saved companion name, personality, communication style, and boundaries.",
              "icon": "settings",
              "tone": "accent",
              "action": { "name": "open-profile-view", "label": "Open Customize your AI", "icon": "arrow-right", "profileView": "ai-customize" }
            },
            {
              "key": "ai-checkins",
              "title": "Check-ins",
              "status": "Frequency and quiet hours",
              "body": "Choose when companion check-ins may appear for this account.",
              "icon": "bell",
              "tone": "success",
              "action": { "name": "open-profile-view", "label": "Open Check-ins", "icon": "arrow-right", "profileView": "ai-checkins" }
            },
            {
              "key": "ai-messaging",
              "title": "Messaging / Draft Review",
              "status": "Human review required",
              "body": "Review and edit existing drafts without sending them to a provider.",
              "icon": "file-text",
              "tone": "warning",
              "action": { "name": "open-profile-view", "label": "Open Messaging and Draft Review", "icon": "arrow-right", "profileView": "ai-messaging" }
            },
            {
              "key": "ai-memory",
              "title": "Memory & Hydration",
              "status": "Consent and imports",
              "body": "Review safe memory status and manage consent-based conversation imports.",
              "icon": "database",
              "tone": "neutral",
              "action": { "name": "open-profile-view", "label": "Open Memory and Hydration", "icon": "arrow-right", "profileView": "ai-memory" }
            },
            {
              "key": "ai-connections",
              "title": "Provider Connections",
              "status": "Connection status",
              "body": "Review account-scoped provider readiness and available connection actions.",
              "icon": "plug",
              "tone": "neutral",
              "action": { "name": "open-profile-view", "label": "Open Provider Connections", "icon": "arrow-right", "profileView": "ai-connections" }
            }
          ]
        },
        {
          "id": "companion-settings",
          "kind": "companion-settings",
          "slot": "primary",
          "profileView": "ai-customize",
          "eyebrow": "AI profile",
          "title": "Customize your AI",
          "body": "These settings are shared with this EPIC account's AI Manager and remain subject to EPIC safety policies.",
          "labels": {
            "back": "Back to AI Manager",
            "settingsAriaLabel": "AI companion settings",
            "loading": "Loading companion settings...",
            "retry": "Try again",
            "save": "Save companion settings",
            "saving": "Saving companion settings...",
            "saved": "Companion settings saved.",
            "unsaved": "You have unsaved companion changes.",
            "offlineSave": "Reconnect before saving companion settings.",
            "policyHeading": "Policies and responsibility",
            "policyAccepted": "Current policy versions accepted.",
            "policyRequired": "Review and accept the current policies before saving.",
            "policyUnavailable": "First-time companion setup is unavailable until the Terms and Complete Privacy Policy, including AI use, are available.",
            "acceptPolicies": "I have read and agree to the EPIC Terms and Conditions and Complete Privacy Policy, including its AI-use section.",
            "unsavedLogout": "Discard unsaved companion changes and sign out?"
          },
          "fields": [
            {
              "key": "ai-name",
              "label": "AI name",
              "placeholder": "Name your AI",
              "help": "This name identifies your companion inside EPIC."
            },
            {
              "key": "base-personality",
              "label": "Personality",
              "placeholder": "Describe who your AI is and how you want it to help.",
              "help": "Use account-facing guidance only. Internal prompts are never exposed here."
            },
            {
              "key": "communication-style",
              "label": "Communication style",
              "help": "Choose the default style for this companion.",
              "options": [
                { "value": "warm", "label": "Warm" },
                { "value": "balanced", "label": "Balanced" },
                { "value": "direct", "label": "Direct" },
                { "value": "playful", "label": "Playful" },
                { "value": "calm", "label": "Calm" }
              ]
            },
            {
              "key": "hard-refusals",
              "label": "What should your AI never do?",
              "placeholder": "Add one refusal boundary per line.",
              "help": "Platform safety rules remain active regardless of these account preferences."
            },
            {
              "key": "soft-boundaries",
              "label": "When should your AI ask you first?",
              "placeholder": "Add one handoff or approval boundary per line.",
              "help": "Use one boundary per line."
            },
            {
              "key": "relationship-boundaries",
              "label": "Relationship boundaries",
              "options": [
                { "value": "non_sexual_non_possessive", "label": "Non-sexual, non-possessive" },
                { "value": "friendly", "label": "Friendly" },
                { "value": "professional", "label": "Professional" },
                { "value": "creator_fan", "label": "Creator / fan" }
              ]
            },
            {
              "key": "ai-reminder-frequency",
              "label": "AI reminder frequency",
              "options": [
                { "value": "low", "label": "Low" },
                { "value": "balanced", "label": "Balanced" },
                { "value": "high", "label": "High" }
              ]
            },
            {
              "key": "redirect-to-real-life",
              "label": "Redirect to real life",
              "options": [
                { "value": "low", "label": "Low" },
                { "value": "balanced", "label": "Balanced" },
                { "value": "high", "label": "High" }
              ]
            }
          ]
        },
        {
          "id": "checkin-settings",
          "kind": "checkin-settings",
          "slot": "primary",
          "profileView": "ai-checkins",
          "eyebrow": "Frequency",
          "title": "Check-ins",
          "body": "Set account-scoped companion check-in frequency, times, timezone, quiet hours, and pause dates.",
          "labels": {
            "back": "Back to AI Manager",
            "settingsAriaLabel": "Companion check-in settings",
            "loading": "Loading check-in settings...",
            "retry": "Try again",
            "frequency": "Check-ins per day",
            "frequencyOff": "Off",
            "frequencyOne": "Once daily",
            "frequencyTwo": "Twice daily",
            "frequencyThree": "Three times daily",
            "timezone": "Timezone",
            "useDeviceTimezone": "Use device timezone",
            "status": "Check-in times",
            "slotMorning": "Morning",
            "slotAfternoon": "Afternoon",
            "slotEvening": "Evening",
            "quietHours": "Quiet hours",
            "enabled": "Use quiet hours",
            "quietStart": "Starts",
            "quietEnd": "Ends",
            "pausedUntil": "Pause through",
            "reset": "Reset check-ins",
            "confirmReset": "Reset check-ins to their defaults?",
            "save": "Save check-ins",
            "saving": "Saving check-ins...",
            "saved": "Check-in settings saved.",
            "unsaved": "You have unsaved check-in changes.",
            "offlineSave": "Reconnect before saving check-ins."
          }
        },
        {
          "id": "messaging-review",
          "kind": "messaging-review",
          "slot": "primary",
          "profileView": "ai-messaging",
          "eyebrow": "Messaging",
          "title": "Messaging / Draft Review",
          "body": "Review existing account drafts. Every draft remains human-controlled and no provider send is available here.",
          "labels": {
            "back": "Back to AI Manager",
            "ariaLabel": "Drafts to review",
            "loading": "Loading drafts...",
            "retry": "Try again",
            "empty": "No drafts need review.",
            "messageEmpty": "Recent message",
            "draftText": "Draft response",
            "noSend": "Edits remain drafts. Provider sending and draft generation are not enabled in this mobile panel.",
            "saveDraft": "Save draft",
            "saving": "Saving draft...",
            "saved": "Draft saved.",
            "unsaved": "You have unsaved draft edits.",
            "offlineSave": "Reconnect before saving this draft.",
            "reject": "Reject draft",
            "confirmReject": "Reject this draft?",
            "humanTakeover": "Take over",
            "confirmHumanTakeover": "Mark this conversation for human takeover?"
          }
        },
        {
          "id": "memory-hydration",
          "kind": "memory-hydration",
          "slot": "primary",
          "profileView": "ai-memory",
          "eyebrow": "Memory",
          "title": "Memory & Hydration",
          "body": "Review safe memory metadata and control consent before importing conversation data for this account.",
          "labels": {
            "back": "Back to AI Manager",
            "settingsAriaLabel": "Memory consent settings",
            "loading": "Loading memory status...",
            "retry": "Try again",
            "profileGrounding": "Profile grounding",
            "memoryStatus": "Memory status",
            "messagesScored": "Messages scored",
            "memoryCells": "Memory cells",
            "uploadComplete": "Imported samples",
            "lastUpdated": "Last updated",
            "styleLearning": "Allow style learning",
            "conversationUpload": "Allow conversational uploads",
            "consentHelp": "Control whether account conversation data may be used to ground this companion's communication style.",
            "save": "Save consent",
            "saving": "Saving consent...",
            "saved": "Consent settings saved.",
            "unsaved": "You have unsaved consent changes.",
            "offlineSave": "Reconnect before saving consent.",
            "chooseFile": "Choose a conversation file",
            "uploadConsent": "I consent to processing this file for conversation style learning.",
            "upload": "Import conversation data",
            "uploading": "Importing conversation data...",
            "desktopUpload": "Mobile supports .txt, .html, .json, .jsonl, .csv, and .zip files up to 40 MB. Use the desktop AI Manager for larger imports."
          }
        },
        {
          "id": "provider-connections",
          "kind": "provider-connections",
          "slot": "primary",
          "profileView": "ai-connections",
          "eyebrow": "Connections",
          "title": "Provider Connections",
          "body": "Review provider readiness for this EPIC account and use only the connection actions currently authorized by the server.",
          "labels": {
            "back": "Back to AI Manager",
            "loading": "Loading provider connections...",
            "retry": "Try again",
            "empty": "No provider connections are available.",
            "status": "No connection action is needed."
          }
        },
        {
          "id": "session-actions",
          "kind": "session-actions",
          "slot": "primary",
          "profileView": "hub",
          "icon": "shield-check",
          "eyebrow": "Security",
          "title": "This session",
          "body": "Two-step verification is available in Account security. Signing out clears account information held by this mobile view.",
          "action": {
            "name": "open-auth-security",
            "label": "Account security",
            "icon": "shield-check"
          },
          "secondaryAction": {
            "name": "logout",
            "label": "Sign out",
            "icon": "log-out"
          }
        }
      ]
    }
  },
  "capabilities": {
    "send": "unavailable",
    "create": "unavailable",
    "olivia": "available"
  },
  "managerCapabilities": {
    "schemaVersion": "mobile-manager-capabilities.v1",
    "workspaces": [
      {
        "key": "overview",
        "operations": [
          { "key": "account-health", "binding": "account-overview", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "provider-connections", "binding": "provider-connections", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "queued-failures", "binding": "overview-queued-failures", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" }
        ]
      },
      {
        "key": "funnels",
        "operations": [
          { "key": "list", "binding": "funnels-list", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "detail", "binding": "funnels-detail", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "edit", "binding": "funnels-edit", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "activation", "binding": "funnels-activation", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "analytics", "binding": "funnels-analytics", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" }
        ]
      },
      {
        "key": "create",
        "operations": [
          { "key": "content-library", "binding": "create-content-library", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "capture-upload", "binding": "create-capture-upload", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "draft-preview", "binding": "create-draft-preview", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "approval", "binding": "create-approval", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" }
        ]
      },
      {
        "key": "scheduler",
        "operations": [
          { "key": "calendar", "binding": "scheduler-calendar", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "schedule", "binding": "scheduler-schedule", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "reschedule", "binding": "scheduler-reschedule", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "cancel", "binding": "scheduler-cancel", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "publish", "binding": "scheduler-publish", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" }
        ]
      },
      {
        "key": "public-profile",
        "operations": [
          { "key": "social-links", "binding": "social-links-settings", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "preview", "binding": "public-profile-preview", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "edit", "binding": "public-profile-edit", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" }
        ]
      },
      {
        "key": "account-security",
        "operations": [
          { "key": "security-center", "binding": "account-security", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "sessions-devices", "binding": "account-sessions-devices", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "data-export", "binding": "account-data-export", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" },
          { "key": "account-deletion", "binding": "account-deletion", "clientSupported": false, "state": "unavailable", "reasonCode": "MOBILE_MANAGER_CLIENT_NOT_IMPLEMENTED" }
        ]
      },
      {
        "key": "companion",
        "operations": [
          { "key": "chat", "binding": "wctek-chat", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "profile", "binding": "companion-settings", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "checkins", "binding": "checkin-settings", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "messaging-review", "binding": "messaging-review", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "memory-controls", "binding": "memory-hydration", "clientSupported": true, "state": "available", "reasonCode": null },
          { "key": "provider-connections", "binding": "provider-connections", "clientSupported": true, "state": "available", "reasonCode": null }
        ]
      }
    ]
  }
}
